import { render, staticRenderFns } from "./SampleDescriptionHelp.vue?vue&type=template&id=3238b802"
import script from "./SampleDescriptionHelp.vue?vue&type=script&lang=js"
export * from "./SampleDescriptionHelp.vue?vue&type=script&lang=js"
import style0 from "./SampleDescriptionHelp.vue?vue&type=style&index=0&id=3238b802&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports